import _ from 'lodash';
import moment from 'moment';

import { TitleEnum } from 'Common/Constants/Enumeration/CommonEnum';
import { ItemEnum, CreateEditPhysicalEnum } from 'Common/FieldEnum';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import { KitchenItemPrepareInHouseFilterEnum } from 'Common/GridHelper';

import * as types from './types';

const INITIAL_STATE = {
  physicalItems: [],
  physicalItemsLoadingError: null,
  fetchPhysicalItems: false,
  loading: false,
  submitted: false,
  submitError: null,
  submitting: false,
  fetchingPhysicalDetail: false,
  selectedPhysicalDetail: null,
  fetchPhysicalDetailError: null,
  fetchPhysicalOnHandError: null,
  checkIncompletePhysical: null,
  checkIncompletePhysicalError: null,
  siteWarningCheck: null,
  siteWarningCheckForError: null,
  physicalOnHandDetail: null,
  fetchingPhysicalOnHand: false,
  isLoadOnHandClicked: false,
  siteWarningDataLoadingError: null,
  fetchSiteWarningDataLoading: false,
};
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.CREATE_EDIT_PHYSICAL_ITEMS:
      return {
        ...state,
        physicalItems: action.payload.map(item => ({
          ...item,
          [ItemEnum.BeginDate]: item[ItemEnum.BeginDate]
            ? moment(item[ItemEnum.BeginDate]).format(DATE_FORMAT_FOR_UI)
            : '',
          [ItemEnum.EndDate]: item[ItemEnum.EndDate]
            ? moment(item[ItemEnum.EndDate]).format(DATE_FORMAT_FOR_UI)
            : '',
          [CreateEditPhysicalEnum.StorageLocationIds]: item[
            CreateEditPhysicalEnum.StorageLocationIds
          ]
            ? item[CreateEditPhysicalEnum.StorageLocationIds].split(',')
            : '',
          [ItemEnum.PriQty]: null,
          [ItemEnum.SecQty]: null,
          [ItemEnum.PrepareInHouse]:
            typeof item[ItemEnum.PrepareInHouse] === 'string'
              ? item[ItemEnum.PrepareInHouse]
              : item[ItemEnum.PrepareInHouse]
              ? KitchenItemPrepareInHouseFilterEnum.Yes
              : KitchenItemPrepareInHouseFilterEnum.No,
        })),
      };

    case types.PHYSICAL_ITEMS_LOADING_ERROR:
      return {
        ...state,
        physicalItemsLoadingError: action.payload,
      };
    case types.PHYSICAL_LOADING:
      return {
        ...state,
        fetchPhysicalItems: action.payload,
      };
    case types.FETCHING_PHYSICAL_DETAIL:
      return {
        ...state,
        fetchingPhysicalDetail: action.payload,
      };
    case types.FETCHING_PHYSICAL_ON_HAND:
      return {
        ...state,
        fetchingPhysicalOnHand: action.payload,
      };
    case types.RE_PHYSICAL_ITEM_LIST:
      let clone = _.clone(state.physicalItems, true);
      let remainedItem = [];
      if (action.payload && action.payload.length) {
        _.forEach(action.payload, item => {
          if (item.PriQty !== null || item.SecQty !== null ) {
            const index = _.findIndex(clone, function(cloneItem) {
              return item.ItemCode === cloneItem.ItemCode;
            });
            if (index !== -1) {
              remainedItem.push(clone[index]);
              clone.splice(index, 1);
            }
          }
        });
      }
      clone = _.concat(remainedItem, clone);
      return {
        ...state,
        physicalItems: clone,
      };
    case types.CLEAR_PHYSICAL_ERROR_SUCCESS:
      return {
        ...state,
        submitted: false,
        submitError: null,
        savePhysicalDetailError: null,
        siteWarningCheckForError: null,
        checkIncompletePhysicalError: null,
      };
    case types.SELECTED_PHYSICAL_DETAIL:
      const selectedPhysicalDetail = action.payload;
      if (
        selectedPhysicalDetail &&
        selectedPhysicalDetail[CreateEditPhysicalEnum.PhysicalItems] &&
        Array.isArray(
          selectedPhysicalDetail[CreateEditPhysicalEnum.PhysicalItems]
        )
      ) {
        selectedPhysicalDetail[
          CreateEditPhysicalEnum.PhysicalItems
        ] = selectedPhysicalDetail[CreateEditPhysicalEnum.PhysicalItems].map(
          item => ({
            ...item,
            [ItemEnum.SecQty]: item[ItemEnum.SecQty] !== null
              ? Number(item[ItemEnum.SecQty]).toFixed(4)
              : null,
            [ItemEnum.BeginDate]: item[ItemEnum.BeginDate]
              ? moment(item[ItemEnum.BeginDate]).format(DATE_FORMAT_FOR_UI)
              : '',
            [ItemEnum.EndDate]: item[ItemEnum.EndDate]
              ? moment(item[ItemEnum.EndDate]).format(DATE_FORMAT_FOR_UI)
              : '',
            [ItemEnum.PrepareInHouse]: item[ItemEnum.PrepareInHouse]
              ? KitchenItemPrepareInHouseFilterEnum.Yes
              : KitchenItemPrepareInHouseFilterEnum.No,
          })
        );
      }
      return {
        ...state,
        selectedPhysicalDetail: selectedPhysicalDetail,
      };
    case types.PHYSICAL_ON_HAND_DETAIL:
      return {
        ...state,
        physicalOnHandDetail: action.payload,
      };
    case types.PHYSICAL_DETAIL_SUBMIT:
      return {
        ...state,
        submitted: true,
      };
    case types.SUBMIT_PHYSICAL_DETAIL_ERROR:
      if (action.payload.Title === TitleEnum.Error) {
        let errorObj = {
          Title: TitleEnum.Error,
          Message: action.payload.Message,
        };
        return {
          ...state,
          submitError: errorObj,
        };
      }
      return {
        ...state,
        submitError: action.payload,
      };
    case types.FETCHING_PHYSICAL_DETAIL_ERROR:
      return {
        ...state,
        fetchPhysicalDetailError: action.payload,
      };
    case types.FETCHING_PHYSICAL_ON_HAND_ERROR:
      return {
        ...state,
        fetchPhysicalOnHandError: action.payload,
      };
    case types.SUBMITTING_PHYSICAL_DETAIL:
      return {
        ...state,
        submitting: action.payload,
      };
    case types.CHECK_INCOMPLETE_PHYSICAL_RESULT:
      return {
        ...state,
        checkIncompletePhysical: action.payload,
      };
    case types.CHECK_INCOMPLETE_PHYSICAL_ERROR:
      return {
        ...state,
        checkIncompletePhysicalError: action.payload,
      };
    case types.SITE_WARNING_CHECK:
      return {
        ...state,
        siteWarningCheck: action.payload,
      };

    case types.SITE_WARNING_ERROR:
      return {
        ...state,
        siteWarningCheck: action.payload,
        siteWarningCheckForError: {
          Title: TitleEnum.Error,
          Message: action.payload.Message,
        },
      };
    case types.SET_IS_LOAD_ONHAND_CLICKED:
      return {
        ...state,
        isLoadOnHandClicked: action.payload,
      };
    case types.SITE_WARNING_DATA_LOADING_ERROR:
      return {
        ...state,
        siteWarningDataLoadingError: action.payload,
      };
    case types.SITE_WARNING_DATA_LOADING:
      return {
        ...state,
        fetchSiteWarningDataLoading: action.payload,
      };
    case types.CLEAR_SITE_WARNING_DATA:
      return {
        ...state,
        siteWarningCheck: null,
        siteWarningCheckForError: null,
      };
    case types.CLEAR_SITE_WARNING_DATA_LOADING_ERROR:
      return {
        ...state,
        siteWarningDataLoadingError: null,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/physical/state/CreateEditPhysical/reducer.js